/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthEmailControllerSendCodeMutationRequest,
  TelegramAuthEmailControllerSendCodeMutationResponse,
  TelegramAuthEmailControllerSendCode400,
  TelegramAuthEmailControllerSendCode401,
  TelegramAuthEmailControllerSendCode403,
  TelegramAuthEmailControllerSendCode429,
} from '../../types/TelegramAuthEmailControllerSendCode.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthEmailSendCode } from '../../methods/telegramAuthEmailSendCode.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthEmailSendCodeMutationKey = () => [{ url: '/api/telegram/auth/email/send-code' }] as const;

export type TelegramAuthEmailSendCodeMutationKey = ReturnType<typeof telegramAuthEmailSendCodeMutationKey>;

/**
 * {@link /api/telegram/auth/email/send-code}
 */
export function useTelegramAuthEmailSendCode<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthEmailControllerSendCodeMutationResponse,
      ResponseErrorConfig<
        | TelegramAuthEmailControllerSendCode400
        | TelegramAuthEmailControllerSendCode401
        | TelegramAuthEmailControllerSendCode403
        | TelegramAuthEmailControllerSendCode429
      >,
      { data: TelegramAuthEmailControllerSendCodeMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthEmailControllerSendCodeMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthEmailSendCodeMutationKey();

  return useMutation<
    TelegramAuthEmailControllerSendCodeMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthEmailControllerSendCode400
      | TelegramAuthEmailControllerSendCode401
      | TelegramAuthEmailControllerSendCode403
      | TelegramAuthEmailControllerSendCode429
    >,
    { data: TelegramAuthEmailControllerSendCodeMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthEmailSendCode(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
